import { JsCookie } from '@Engage.Core';
import { MemoryProxyStorage } from '../memoryProxy/MemoryProxyStorage';
export class CookiesStorage {
    constructor() {
        this.cookies = JsCookie.getInstance();
        return MemoryProxyStorage.applyProxy(this, "CookiesStorage");
    }
    static getInstance() {
        if (!CookiesStorage.instance) {
            CookiesStorage.instance = new CookiesStorage();
        }
        return CookiesStorage.instance;
    }
    isSupported() {
        const cookies = JsCookie.getInstance();
        let result = false;
        try {
            const key = "isSupportedCookieKey";
            const value = "isSupportedCookieValue";
            cookies.set(key, value, null);
            if (cookies.get(key) === value) {
                cookies.remove(key, null);
                result = true;
            }
        }
        catch (ex) {
            result = false;
        }
        finally {
            return result;
        }
    }
    get(key, converter = {}) {
        return this.cookies.get(key, converter);
    }
    set(key, value, options, converter = {}) {
        if (options && options.daysOfLife) {
            let expireDate = new Date();
            expireDate.setDate(expireDate.getDate() + options.daysOfLife);
            options.expires = expireDate;
        }
        this.cookies.set(key, value, options, converter);
        return !this.checkIsNullOrUndefined(this.get(key, converter));
    }
    delete(key, options) {
        return this.cookies.remove(key, options);
    }
    clear() {
        document.cookie.split(';').forEach((cookie) => {
            const [name] = cookie.split('=').map(c => c.trim());
            let domains = window.location.hostname.split('.');
            for (let d = 0; d <= domains.length; d++) {
                var pathnames = window.location.pathname.split('/');
                for (let p = 0; p < pathnames.length; p++) {
                    this.delete(name, {
                        domain: domains.slice(d, domains.length).join('.'),
                        path: pathnames.slice(0, p + 1).join('/') || '/'
                    });
                }
            }
        });
        return true;
    }
    checkIsNullOrUndefined(result) {
        return result === undefined || result === null;
    }
}
